export default __webpack_public_path__ + "static/media/H1016.3.7a57f106.mp3";